/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    [
      'நள்.', 'நண்.', 'அதி.', 'கா.', 'மதி.', 'பிற்.', 'மா.',
      'அந்தி மா.', 'இர.'
    ],
    [
      'நள்ளிரவு', 'நண்பகல்', 'அதிகாலை', 'காலை',
      'மதியம்', 'பிற்பகல்', 'மாலை',
      'அந்தி மாலை', 'இரவு'
    ],
  ],
  [
    [
      'நள்.', 'நண்.', 'அதி.', 'கா.', 'மதி.', 'பிற்.', 'மா.',
      'அந்தி மா.', 'இ.'
    ],
    [
      'நள்ளிரவு', 'நண்பகல்', 'அதிகாலை', 'காலை',
      'மதியம்', 'பிற்பகல்', 'மாலை',
      'அந்தி மாலை', 'இரவு'
    ],
  ],
  [
    '00:00', '12:00', ['03:00', '05:00'], ['05:00', '12:00'], ['12:00', '14:00'],
    ['14:00', '16:00'], ['16:00', '18:00'], ['18:00', '21:00'], ['21:00', '03:00']
  ]
];
